import * as React from 'react';
import { useGroupSkills } from '../../../hooks/useGroupSkills';
import { mapSkillsSummary } from '../utils';
var useSkillsSummary = function (_a) {
    var groupId = _a.groupId, domains = _a.domains, minPlacementGradeValue = _a.minPlacementGradeValue;
    var domainIds = React.useMemo(function () { return domains.map(function (el) { return el.id; }); }, [domains]);
    var groupSkills = useGroupSkills({
        groupId: groupId,
        domainId: domainIds,
    }).data;
    var _b = React.useState(null), skillsSummary = _b[0], setSkillsSummary = _b[1];
    var _c = React.useState(false), onlyPKStudents = _c[0], setOnlyPKStudents = _c[1];
    React.useEffect(function () {
        if (groupSkills) {
            var summary = mapSkillsSummary({
                domains: domains,
                groupSkills: groupSkills,
                minPlacementGradeValue: minPlacementGradeValue,
            });
            setSkillsSummary(summary);
            setOnlyPKStudents(groupSkills.students.every(function (student) { return student.curriculumGrade === 'PK'; }));
        }
    }, [groupSkills, domains, minPlacementGradeValue]);
    return {
        skillsSummary: skillsSummary,
        onlyPKStudents: onlyPKStudents,
    };
};
export { useSkillsSummary };
